import { defineFcm } from '../shared/factory';

export const FCM_STARFISH_SAP3_RECOMMENDED_ANGLES = defineFcm('starfish_sap3_recommended_angles')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-starfish',
		scope: 'corgi-front-end',
		context: 'starfish recommended angles in SAP flow',
		description: 'Controls display of recommended angles feature in SAP flow.',
		import: false,
		deprecated: 'Experiment concluded',
	});
